import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface ResolveProductConditionsParameter {
  lineSheetSetId: number;
}

export interface ResolveProductConditionsRequest {
  brandId?: number;
  lineSheetId?: number;
  // 시즌별 inspect-parsing — SEASON 타겟에서 사용.
  season?: string;
  orderRulesText?: string;
  // 오더룰 파일이 여러개일 때 사용자가 선택한 파일. axios 인터셉터가 uno_file_id 로 직렬화한다.
  unoFileId?: number;
}

export interface ResolveProductConditionsResponse {
  jobId: string;
  status: string;
  totalProducts: number;
}

export const resolveProductConditionsTemplateUrl =
  "/line-sheet-sets/:lineSheetSetId/inspect-parsing";

export const resolveProductConditionsKey: YWRKey<ResolveProductConditionsParameter> =
  {
    url: (parameter) =>
      calcUrl(resolveProductConditionsTemplateUrl, parameter),
    method: "post",
  };

export default function useResolveProductConditions() {
  const fetcher = useFetcher<
    ResolveProductConditionsRequest,
    ResolveProductConditionsResponse
  >();
  return useYWR(resolveProductConditionsKey, fetcher);
}
